import React from 'react';

import * as styles from './index.module.scss';

const FormSteps = ({ stepIndex = 0, totalSteps = 4 }) => {
  const steps = Array.from({ length: totalSteps });
  return (
    <div className={styles['form-steps-container']}>
      {steps.map((ele, i) => (
        <div className={styles['step-container']} key={i}>
          <div className={`${styles['step']} ${i === stepIndex ? styles['current'] : ''} ${i < stepIndex ? styles['completed'] : ''}`}></div>
          {i < totalSteps - 1 && <div className={`${styles['divider']}  ${i < stepIndex ? styles['current'] : ''}`}></div>}
        </div>
      ))}
    </div>
  );
};

export default FormSteps;
